import React, { useRef, useState } from 'react'
import { IconButton } from '@st-operations/uikit/src/v2/index.js'
import pretty from '@st-operations/uikit/lib/pretty'
import format from '@st-operations/uikit/lib/format'

import { useModal } from '_hooks'

import DomainDetailsModal from '../domain-details-modal/index.jsx'
import { useLayoutEffect } from 'react'

const DomainsRow = ({
  domain,
  description,
  descriptors,
  industries,
  index,
  categories,
  totalEvents,
  totalUsers,
  size,
  deviceTypes,
  eventTypes,
  urls,
  hideDescriptions,
}) => {
  const { isOpen, handleOpenModal, handleCloseModal } = useModal(false)
  const [showMoreButton, setShowMoreButton] = useState(false)
  const descriptionRef = useRef(null)
  const percentage = totalEvents
    ? (Math.round(((size * 100) / totalEvents) * 10) / 10).toFixed(2)
    : 0

  // Turns games/video_games&_consoles/sports_games into Sports Games
  const categoriesString = categories
    .map((category) => {
      const categoriesTaxonomy = category.category.split('/')
      const lastCategory = categoriesTaxonomy[categoriesTaxonomy.length - 1]
      return pretty(lastCategory)
    })
    .join(', ')

  useLayoutEffect(() => {
    if (descriptionRef.current) {
      const el = descriptionRef.current
      if (el.offsetWidth < el.scrollWidth) {
        setShowMoreButton(true)
      }
    }
  }, [])

  return (
    <tr className="highlights-domains-table__row">
      <td className="highlights-domains-table__cell ranking">{index + 1}</td>
      <td className="highlights-domains-table__cell domain">
        <a
          href={`http://${domain}`}
          target="_blank"
          rel="noopener noreferrer"
          className="highlights-domains-table__domain-link"
        >
          {domain}
        </a>
        <If condition={description && !hideDescriptions}>
          <div
            style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              maxWidth: '50ch',
            }}
          >
            <p ref={descriptionRef} className="highlights-domains-table__description">
              {description}
            </p>
            <If condition={showMoreButton}>
              <button
                className="highlights-domains-table__description-button"
                onClick={handleOpenModal}
                type="button"
              >
                see more
              </button>
            </If>
          </div>
        </If>
      </td>
      <td className="highlights-domains-table__cell domain">{categoriesString}</td>
      <td className="highlights-domains-table__cell center total">
        {format('metric', totalUsers)}
      </td>
      <td className="highlights-domains-table__cell center total">{format('metric', size)}</td>
      <td className="highlights-domains-table__cell center ratio">{percentage}%</td>
      <td className="highlights-domains-table__cell center expand">
        <IconButton
          iconProps={{ icon: 'expand', type: 'outline', width: '24px', height: '24px' }}
          onClick={handleOpenModal}
        />
      </td>
      <If condition={isOpen}>
        <DomainDetailsModal
          isOpen={isOpen}
          onClose={handleCloseModal}
          domain={domain}
          description={description}
          descriptors={descriptors}
          industries={industries}
          percentage={percentage}
          totalEvents={format('metric', size)}
          totalUsers={format('metric', totalUsers)}
          deviceTypes={deviceTypes}
          eventTypes={eventTypes}
          urls={urls}
        />
      </If>
    </tr>
  )
}

export default DomainsRow
